import BaseListPresenter from "../../../base/BaseListPresenter";
import { formatDate } from "../../../components/common/Converter";
import { findObjectUseCase } from "../../../usecases/object";

class MedicalRecordPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["employee"];
    this.keys = []; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      console.log("asasasas", objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async GenerateCSV(fields) {
    const query = this.createQuery();
    query.limit = 0;
    const objects = await findObjectUseCase().execute(
      this.view.getCollectionName(),
      query
    );
    let csvContent = `${fields}\n`; // CSV header

    objects.forEach((item) => {
      const empName = `${item.employee.Firstname} ${
        item.employee.Middlename || ""
      } ${item.employee.surname}`;
      const createdAt = this.wrapInQuotes(formatDate(item.createdAt));
      const updatedAt = this.wrapInQuotes(formatDate(item.updatedAt));
      const employee = this.wrapInQuotes(empName);
      const dateOfBirth = this.wrapInQuotes(formatDate(item.dateOfBirth));
      const gender = this.wrapInQuotes(item.gender);
      const department = this.wrapInQuotes(item.department);
      const contactDetails = this.wrapInQuotes(item.contactDetails);
      const emergencyContact = this.wrapInQuotes(item.emergencyContact);
      const philhealthNumber = this.wrapInQuotes(item.philhealthNumber);
      const pastMedicalConditions = this.wrapInQuotes(
        item.pastMedicalConditions
      );
      const familyMedicalHistory = this.wrapInQuotes(item.familyMedicalHistory);
      const surgicalHistory = this.wrapInQuotes(item.surgicalHistory);
      const allergies = this.wrapInQuotes(item.allergies);
      const obstetricHistory = this.wrapInQuotes(item.obstetricHistory);
      const vaccine = this.wrapInQuotes(item.vaccine);
      const doses = this.wrapInQuotes(item.doses);
      const dateOfVaccination = this.wrapInQuotes(
        formatDate(item.dateOfVaccination)
      );
      const remarks = this.wrapInQuotes(item.remarks);
      const specifyIllness = this.wrapInQuotes(item.specifyIllness);

      csvContent += `${createdAt},${updatedAt},${employee},${dateOfBirth},${gender},${department},${contactDetails},${emergencyContact},${philhealthNumber},${pastMedicalConditions},${familyMedicalHistory},${surgicalHistory},${allergies},${obstetricHistory},${vaccine},${doses},${dateOfVaccination},${remarks},${specifyIllness}\n`;
    });

    // Create a blob from CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a link element and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Medical Rec.csv`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // Helper function to wrap values in quotes if necessary
  wrapInQuotes(value) {
    // Convert to string and check if it contains a comma or new line
    const strValue = String(value);
    if (strValue.includes(",") || strValue.includes("\n")) {
      return `"${strValue.replace(/"/g, '""')}"`; // Wrap in quotes and escape any existing quotes
    }
    return strValue;
  }
}
export default MedicalRecordPresenter;
